import {
  RESET_SITES,
  SET_SITES,
  SITE_UPDATE,
  RECONCILE_SITES,
} from "../actions/index";
import { reconcileById } from "./reconcile";

const initialData = { byId: {}, allIds: [] };

const sites = (state = initialData, action) => {
  switch (action.type) {
    case SET_SITES:
      return action.payload;
    case RECONCILE_SITES:
      return reconcileById(state, action.payload);
    case RESET_SITES:
      return initialData;
    case SITE_UPDATE:
      let update = {
        [action.payload.siteGuid]: {
          ...state.byId[action.payload.siteGuid],
          latitude: action.payload.latitude,
          longitude: action.payload.longitude,
          name: action.payload.name,
          city: action.payload.city,
          country: action.payload.country,
          createdAt: action.payload.createdAt,
          modifiedAt: action.payload.modifiedAt,
          customer: action.payload.customer,
          deleteAt: action.payload.deleteAt,
          gateways: action.payload.gateways,
          siteGuid: action.payload.siteGuid,
          isHidden: action.payload.isHidden,
        },
      };
      return { ...state, byId: { ...state.byId, ...update } };
    default:
      return state;
  }
};

export default sites;
